<template>
  <div
    :class="[
      'letter-grid-container mx-auto',
      doubleRow
        ? 'max-w-[460px] w-full'
        : 'max-w-[280px] min-[480px]:max-w-[360px] sm:max-w-[450px] md:max-w-[540px] lg:max-w-[600px] min-[1200px]:max-w-[650px] min-[1440px]:max-w-[720px]',
    ]"
    role="list"
    :aria-label="STRINGS.aria.labels.availableLettersForWord"
    data-phase-grid
  >
    <div class="letter-grid" :class="{ 'letter-grid--double-row': doubleRow }">
      <span
        v-for="letter in letters"
        :key="letter.char"
        class="letter-tile"
        :class="{ 'letter-tile--urgent': urgent }"
        role="listitem"
        :aria-label="STRINGS.templates.availableLetter(letter.char)"
      >
        {{ letter.char }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Letter } from '@/types/generated';
import STRINGS from '@/constants/strings';

defineProps<{
  letters: Letter[];
  urgent?: boolean;
  /** Force a 5-column (double-row) layout for the in-round arena card. */
  doubleRow?: boolean;
}>();
</script>
